import {
  GET_VENDORS,
  GET_VENDORS_SUCCESS,
  API_ERROR,
  GET_VENDORS_FOR_USER,
  UPDATE_CLIENT_CONFIGS_FAIL,
  UPDATE_CLIENT_CONFIGS_SUCCESS,
  UPDATE_CLIENT_CONFIGS,
  GET_CLIENTS_TABLE_DATA,
  GET_CLIENTS_TABLE_DATA_SUCCESS,
  GET_CLIENTS_TABLE_DATA_FAILED,
  ADD_CLIENT,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAILED,
  POST_CLIENT_SUCCESS_MANAGER,
  POST_CLIENT_SUCCESS_MANAGER_SUCCESS,
  POST_CLIENT_SUCCESS_MANAGER_FAILED,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILED,
  OPEN_DELETE_CLIENT_MODAL,
  HIDE_DELETE_CLIENT_MODAL,
  GET_CLIENT,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_FAILED,
  GET_CLIENT_SUCCESS_MANAGER,
  GET_CLIENT_SUCCESS_MANAGER_SUCCESS,
  GET_CLIENT_SUCCESS_MANAGER_FAILED,
  RESET_CLIENT_FORM,
  UPDATE_CLIENT,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAILED,
  UPDATE_CLIENT_SUCCESS_MANAGER,
  UPDATE_CLIENT_SUCCESS_MANAGER_SUCCESS,
  UPDATE_CLIENT_SUCCESS_MANAGER_FAILED,
  GET_VENDOR_CONFIG,
  GET_VENDOR_CONFIG_SUCCESS,
  GET_VENDOR_CONFIG_FAILED,
  GET_VENDOR_EMAIL_CONFIG,
  GET_VENDOR_EMAIL_CONFIG_SUCCESS,
  GET_VENDOR_EMAIL_CONFIG_FAILED,
  GET_EXPERIENCES_FEATURES,
  GET_EXPERIENCES_FEATURES_SUCCESS,
  GET_EXPERIENCES_FEATURES_FAILED,
  GET_LANDING_SCREEN_FEATURES,
  GET_LANDING_SCREEN_FEATURES_SUCCESS,
  GET_LANDING_SCREEN_FEATURES_FAILED,
  UPDATE_CLIENT_FEATURES,
  UPDATE_CLIENT_FEATURES_SUCCESS,
  UPDATE_CLIENT_FEATURES_FAILED,
  UPDATE_CLIENT_SETTINGS,
  UPDATE_CLIENT_SETTINGS_SUCCESS,
  UPDATE_CLIENT_SETTINGS_FAILED,
  RESET_CLIENT_SETTINGS_FORM,
  UPDATE_CLIENT_EMAIL_CONFIG,
  UPDATE_CLIENT_EMAIL_CONFIG_SUCCESS,
  UPDATE_CLIENT_EMAIL_CONFIG_FAILED,
  GET_VENDOR_PAYMENT_CONFIG,
  GET_VENDOR_PAYMENT_CONFIG_SUCCESS,
  GET_VENDOR_PAYMENT_CONFIG_FAILED,
  UPDATE_VENDOR_PAYMENT_CONFIG,
  UPDATE_VENDOR_PAYMENT_CONFIG_SUCCESS,
  UPDATE_VENDOR_PAYMENT_CONFIG_FAILED,
  GET_VENDORS_FOR_USER_SUCCESS,
  GET_VENDORS_FOR_USER_FAILED,
} from "store/clients/actionTypes"

export const getVendorsForUser = values => {
  return {
    type: GET_VENDORS_FOR_USER,
    payload: { values },
  }
}

export const getVendorsForUserSuccess = response => ({
  type: GET_VENDORS_FOR_USER_SUCCESS,
  payload: response,
})

export const getVendorsForUserFailed = error => ({
  type: GET_VENDORS_FOR_USER_FAILED,
  payload: error,
})

export const getVendors = values => {
  return {
    type: GET_VENDORS,
    payload: { values },
  }
}

export const resetVendors = () => {
  return {
    type: GET_VENDORS_SUCCESS,
    payload: [],
  }
}

export const getVendorsSuccess = vendors => {
  return {
    type: GET_VENDORS_SUCCESS,
    payload: vendors,
  }
}

export const updateClientConfigs = params => ({
  type: UPDATE_CLIENT_CONFIGS,
  payload: params,
})

export const updateClientConfigsSuccess = () => ({
  type: UPDATE_CLIENT_CONFIGS_SUCCESS,
})

export const updateClientConfigsFail = error => ({
  type: UPDATE_CLIENT_CONFIGS_FAIL,
  payload: error,
})

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const getClientsTableData = params => ({
  type: GET_CLIENTS_TABLE_DATA,
  payload: params,
})

export const getClientsTableDataSuccess = response => ({
  type: GET_CLIENTS_TABLE_DATA_SUCCESS,
  payload: response,
})

export const getClientsTableDataFailed = error => ({
  type: GET_CLIENTS_TABLE_DATA_FAILED,
  payload: error,
})

export const addClient = params => ({
  type: ADD_CLIENT,
  payload: params,
})

export const addClientSuccess = response => ({
  type: ADD_CLIENT_SUCCESS,
  payload: response,
})

export const addClientFailed = error => ({
  type: ADD_CLIENT_FAILED,
  payload: error,
})

export const postClientSuccessManager = params => ({
  type: POST_CLIENT_SUCCESS_MANAGER,
  payload: params,
})

export const postClientSuccessManagerSuccess = response => ({
  type: POST_CLIENT_SUCCESS_MANAGER_SUCCESS,
  payload: response,
})

export const postClientSuccessManagerFailed = error => ({
  type: POST_CLIENT_SUCCESS_MANAGER_FAILED,
  payload: error,
})

export const deleteClient = params => ({
  type: DELETE_CLIENT,
  payload: params,
})

export const deleteClientSuccess = response => ({
  type: DELETE_CLIENT_SUCCESS,
  payload: response,
})

export const deleteClientFailed = error => ({
  type: DELETE_CLIENT_FAILED,
  payload: error,
})

export const openDeleteClientModal = () => ({
  type: OPEN_DELETE_CLIENT_MODAL,
  payload: {},
})

export const hideDeleteClientModal = () => ({
  type: HIDE_DELETE_CLIENT_MODAL,
  payload: {},
})

export const getClient = params => ({
  type: GET_CLIENT,
  payload: params,
})

export const getClientSuccess = response => ({
  type: GET_CLIENT_SUCCESS,
  payload: response,
})

export const getClientFailed = error => ({
  type: GET_CLIENT_FAILED,
  payload: error,
})

export const getClientSuccessManager = params => ({
  type: GET_CLIENT_SUCCESS_MANAGER,
  payload: params,
})

export const getClientSuccessManagerSuccess = response => ({
  type: GET_CLIENT_SUCCESS_MANAGER_SUCCESS,
  payload: response,
})

export const getClientSuccessManagerFailed = error => ({
  type: GET_CLIENT_SUCCESS_MANAGER_FAILED,
  payload: error,
})

export const resetClientForm = () => ({
  type: RESET_CLIENT_FORM,
  payload: {},
})

export const updateClient = params => ({
  type: UPDATE_CLIENT,
  payload: params,
})

export const updateClientSuccess = response => ({
  type: UPDATE_CLIENT_SUCCESS,
  payload: response,
})

export const updateClientFailed = error => ({
  type: UPDATE_CLIENT_FAILED,
  payload: error,
})

export const updateClientSuccessManager = params => ({
  type: UPDATE_CLIENT_SUCCESS_MANAGER,
  payload: params,
})

export const updateClientSuccessManagerSuccess = response => ({
  type: UPDATE_CLIENT_SUCCESS_MANAGER_SUCCESS,
  payload: response,
})

export const updateClientSuccessManagerFailed = error => ({
  type: UPDATE_CLIENT_SUCCESS_MANAGER_FAILED,
  payload: error,
})

export const getVendorConfig = params => ({
  type: GET_VENDOR_CONFIG,
  payload: params,
})

export const getVendorConfigSuccess = response => ({
  type: GET_VENDOR_CONFIG_SUCCESS,
  payload: response,
})

export const getVendorConfigFailed = error => ({
  type: GET_VENDOR_CONFIG_FAILED,
  payload: error,
})

export const getVendorEmailConfig = params => ({
  type: GET_VENDOR_EMAIL_CONFIG,
  payload: params,
})

export const getVendorEmailConfigSuccess = response => ({
  type: GET_VENDOR_EMAIL_CONFIG_SUCCESS,
  payload: response,
})

export const getVendorEmailConfigFailed = error => ({
  type: GET_VENDOR_EMAIL_CONFIG_FAILED,
  payload: error,
})

export const getExperiencesFeatures = params => ({
  type: GET_EXPERIENCES_FEATURES,
  payload: params,
})

export const getExperiencesFeaturesSuccess = response => ({
  type: GET_EXPERIENCES_FEATURES_SUCCESS,
  payload: response,
})

export const getExperiencesFeaturesFailed = error => ({
  type: GET_EXPERIENCES_FEATURES_FAILED,
  payload: error,
})

export const getLandingScreenFeatures = params => ({
  type: GET_LANDING_SCREEN_FEATURES,
  payload: params,
})

export const getLandingScreenFeaturesSuccess = response => ({
  type: GET_LANDING_SCREEN_FEATURES_SUCCESS,
  payload: response,
})

export const getLandingScreenFeaturesFailed = error => ({
  type: GET_LANDING_SCREEN_FEATURES_FAILED,
  payload: error,
})

export const updateClientFeatures = params => ({
  type: UPDATE_CLIENT_FEATURES,
  payload: params,
})

export const updateClientFeaturesSuccess = response => ({
  type: UPDATE_CLIENT_FEATURES_SUCCESS,
  payload: response,
})

export const updateClientFeaturesFailed = error => ({
  type: UPDATE_CLIENT_FEATURES_FAILED,
  payload: error,
})

export const updateClientSettings = params => ({
  type: UPDATE_CLIENT_SETTINGS,
  payload: params,
})

export const updateClientSettingsSuccess = response => ({
  type: UPDATE_CLIENT_SETTINGS_SUCCESS,
  payload: response,
})

export const updateClientSettingsFailed = error => ({
  type: UPDATE_CLIENT_SETTINGS_FAILED,
  payload: error,
})

export const resetClientSettingsForm = () => ({
  type: RESET_CLIENT_SETTINGS_FORM,
  payload: {},
})

export const updateClientEmailConfig = params => ({
  type: UPDATE_CLIENT_EMAIL_CONFIG,
  payload: params,
})

export const updateClientEmailConfigSuccess = response => ({
  type: UPDATE_CLIENT_EMAIL_CONFIG_SUCCESS,
  payload: response,
})

export const updateClientEmailConfigFailed = error => ({
  type: UPDATE_CLIENT_EMAIL_CONFIG_FAILED,
  payload: error,
})

export const getVendorPaymentConfig = params => ({
  type: GET_VENDOR_PAYMENT_CONFIG,
  payload: params,
})

export const getVendorPaymentConfigSuccess = response => ({
  type: GET_VENDOR_PAYMENT_CONFIG_SUCCESS,
  payload: response,
})

export const getVendorPaymentConfigFailed = error => ({
  type: GET_VENDOR_PAYMENT_CONFIG_FAILED,
  payload: error,
})

export const updateVendorPaymentConfig = params => ({
  type: UPDATE_VENDOR_PAYMENT_CONFIG,
  payload: params,
})

export const updateVendorPaymentConfigSuccess = response => ({
  type: UPDATE_VENDOR_PAYMENT_CONFIG_SUCCESS,
  payload: response,
})

export const updateVendorPaymentConfigFailed = error => ({
  type: UPDATE_VENDOR_PAYMENT_CONFIG_FAILED,
  payload: error,
})
